import React from 'react';
import { Box } from '@chakra-ui/react';
import SchedulerCalendar from './SchedulerCalendar';

const SchedulerDetail = ({
  appointmentList,
  holidayList,
  productsList,
  handleUpdateEvent,
  vehicleService,
  selectedEvent,
  setSelectedEvent,
  putVehicleService,
  putDynamicTest,
  putVehicleData,
  statusList,
  mechanicsList,
  vehicleIdsWithAlerts,
  onAlertsChanged,
  onAppointmentsRefresh,
  onAppointmentRangeChange,
  onVehicleServiceUpdated,
  onAppointmentLocalUpdate,
}) => (
  <Box h="100%" minH={0} display="flex" flexDirection="column" overflow="hidden">
    <SchedulerCalendar
      appointmentList={appointmentList}
      holidayList={holidayList}
      handleUpdateEvent={handleUpdateEvent}
      vehicleService={vehicleService}
      selectedEvent={selectedEvent}
      setSelectedEvent={setSelectedEvent}
      putVehicleService={putVehicleService}
      putDynamicTest={putDynamicTest}
      productsList={productsList}
      putVehicleData={putVehicleData}
      statusList={statusList}
      mechanicsList={mechanicsList}
      vehicleIdsWithAlerts={vehicleIdsWithAlerts}
      onAlertsChanged={onAlertsChanged}
      onAppointmentsRefresh={onAppointmentsRefresh}
      onAppointmentRangeChange={onAppointmentRangeChange}
      onVehicleServiceUpdated={onVehicleServiceUpdated}
      onAppointmentLocalUpdate={onAppointmentLocalUpdate}
    />
  </Box>
);

export default SchedulerDetail;
